//Reset data
export const RESET = "PERMISSION_UPDATE_RESET"

export const SET_IS_UPDATED = "PERMISSION_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "PERMISSION_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "PERMISSION_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "PERMISSION_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "PERMISSION_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "PERMISSION_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "PERMISSION_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "PERMISSION_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "PERMISSION_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "PERMISSION_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "PERMISSION_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "PERMISSION_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "PERMISSION_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "PERMISSION_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "PERMISSION_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "PERMISSION_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "PERMISSION_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "PERMISSION_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "PERMISSION_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "PERMISSION_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "PERMISSION_UPDATE_SET_MODAL_TYPE"